<template>
  <div class="part general list-column">
    <div class="header">
      <h3>{{ title }}</h3>
    </div>
    <div class="content animated fadeInUp" v-if="list">
      <div class="list-item animated fadeIn" v-for="item in list" :key="item._id">
        <section>
          <div class="headline d-flex flex-column">
            <h5 class="name">{{ item.name }}</h5>
            <span>Creator: {{ item.created_by.display_name }}</span>
            <span>Due: {{ item.deadline | moment('lll') }}</span>
          </div>
          <div class="body">
            <div class="description">
              {{ item.description }}
            </div>
            <div class="links">
              <div class="project">
                <router-link :to="`/pm/project/${item.project}`">[See the project]</router-link>
              </div>
            </div>
            <div class="participants">
              <span class="participant" v-for="participant in item.participants" :key="participant._id">
                <i class="fe fe-user"></i> {{ participant.display_name }}
              </span>
            </div>
          </div>

          <a-button-group class="actions">
            <a-button v-if="type !== 'waiting'" @click="onChangeProgress(item, 'waiting')">Waiting</a-button>
            <a-button v-if="type !== 'in-progress'" @click="onChangeProgress(item, 'in-progress')"
              >In-progress</a-button
            >
            <a-button v-if="type !== 'completed'" @click="onChangeProgress(item, 'completed')">Done</a-button>
          </a-button-group>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectBriefingDrawer from '../drawers/ProjectBriefingDrawer.vue'
export default {
  name: 'list-column',
  props: ['type', 'title', 'list'],
  methods: {
    onChangeProgress(task, progress) {
      this.$emit('progressChanged', { task, progress })
    },
  },
}
</script>

<style lang="scss" scoped>
.list-column {
  background: whitesmoke;
  padding: 1rem;
  border-radius: 0.5rem;
  .header {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .content {
    .list-item {
      padding: 2rem 1rem;
      border-radius: 5px;
      background: #fff;
      margin-bottom: 1rem;
      border: 1px solid #dfdfdf;

      .headline {
        span {
          font-size: 14px;
        }
      }

      .body {
        .description {
          font-size: 14px;
          background: #fff7b4;
          padding: 0.6rem;
          border-radius: 5px;
          margin: 0.5rem -0.3rem;
        }

        .links {
          padding: 4px 0;
          .project {
            text-align: center;
          }
        }
        .participants {
          display: flex;
          justify-content: center;
          align-items: center;
          .participant {
            font-size: 14px;
            font-weight: 600;
            text-decoration: underline;
            padding: 0 5px;
          }
        }
      }

      .actions {
        margin-top: 1rem;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
